// removed by extract-text-webpack-plugin
module.exports = {"container":"_03a1c9fb65_src-common-_DateInput_container","label":"c1d7cf292f_src-common-_DateInput_label"};


//////////////////
// WEBPACK FOOTER
// ./src/common/DateInput.css
// module id = 1479
// module chunks = 0